import React from 'react';
import GoogleAnalytics from 'react-ga';
import { NavLink } from 'react-router-dom';
import './Header.css'
import { withRouter } from 'react-router'

import { Navbar, NavbarGroup, Alignment, NavbarHeading, NavbarDivider, Button, Classes, Popover, Menu, MenuItem, Position } from '@blueprintjs/core';

import imgLogoHeader from '../../assets/images/logo-header.png'
import imgNtLogo from '../../assets/images/NOVATEC-rgb-weiss-cyan-tuerkis_schutz.png'

class Header extends React.Component {

    constructor(props) {
        super(props);

        this.toLandscape = this.toLandscape.bind(this);
        this.toHome = this.toHome.bind(this);
        this.toStatistics = this.toStatistics.bind(this);
        this.toBlog = this.toBlog.bind(this);
        this.toFaq = this.toFaq.bind(this);
        this.toGlossary = this.toGlossary.bind(this);
    }

    toStatistics() {
        this.props.history.push('/statistics');
    };

    toLandscape() {
        this.props.history.push('/landscape');
    };

    toBlog() {
        this.props.history.push('/blog');
    };

    toHome() {
        this.props.history.push('/');
    };

    toFaq() {
        this.props.history.push('/faq');
    }

    toGlossary() {
        this.props.history.push('/glossary');
    }

    componentDidUpdate() {
        window.scrollTo(0, 0);
    };

    render() {
        return (
            <Navbar className={Classes.DARK} fixedToTop={true}>

                <NavbarGroup align={Alignment.LEFT}>
                    <NavbarHeading className="navbar-heading">
                        <img className="header-logo" src={imgLogoHeader} alt="OpenAPM" />
                        <NavLink className="nav-link" to="/" >OpenAPM</NavLink>
                    </NavbarHeading>
                    <NavbarDivider />
                    <div className={Classes.TEXT_MUTED + " header-powered-by"}>
                        Powered by <GoogleAnalytics.OutboundLink className="nav-link" eventLabel="Header-NT-APM" to="https://www.novatec-gmbh.de/en/consulting/open-digital-experience-management/" target="_blank" rel="noopener"><img src={imgNtLogo} className="header--ntlogo" alt="Novatec Consulting GmbH" /></GoogleAnalytics.OutboundLink>
                    </div>
                </NavbarGroup>
                <NavbarGroup align={Alignment.RIGHT}>
                    <Popover targetClassName="header-burger-menu" content={
                        <Menu>
                            <MenuItem className="nav-button" icon="home" onClick={this.toHome} text="Home" disabled={this.props.location.pathname === '/'}/>
                            <MenuItem className="nav-button" icon="layout-balloon" onClick={this.toLandscape} text="Landscape" disabled={this.props.location.pathname.startsWith('/landscape')}/>
                            <MenuItem className="nav-button" icon="edit" onClick={this.toBlog} text="Blog" disabled={this.props.location.pathname.startsWith('/blog')}/>
                            <MenuItem className="nav-button" icon="predictive-analysis" onClick={this.toStatistics} text="Statistics" disabled={this.props.location.pathname.startsWith('/statistics')}/>
                            <MenuItem className="nav-button" icon="chat" onClick={this.toFaq} text="FAQ" disabled={this.props.location.pathname.startsWith('/faq')}/>
                            <MenuItem className="nav-button" icon="book" onClick={this.toGlossary} text="Glossary" disabled={this.props.location.pathname.startsWith('/glossary')}/>
                        </Menu>
                    } position={Position.LEFT}>
                        <Button className="pt-minimal nav-button" icon="menu" />
                    </Popover>
                    <NavLink to="/" className="nav-link expanded-nav-link">
                        <Button className="pt-minimal nav-button" icon="home" text="Home" disabled={this.props.location.pathname === '/'} />
                    </NavLink>
                    <NavLink to="/landscape" className="nav-link expanded-nav-link">
                        <Button className="pt-minimal nav-button" icon="layout-balloon" text="OpenAPM Landscape" disabled={this.props.location.pathname.startsWith('/landscape')} />
                    </NavLink>
                    <NavLink to="/blog" className="nav-link expanded-nav-link">
                        <Button className="pt-minimal nav-button" icon="edit" text="Blog" disabled={this.props.location.pathname.startsWith('/blog')} />
                        {/*<div className="label-new-blog"><p>new</p></div>*/}
                    </NavLink>
                    <NavLink to="/statistics" className="nav-link expanded-nav-link">
                        <Button className="pt-minimal nav-button" icon="predictive-analysis" text="Statistics" disabled={this.props.location.pathname.startsWith('/statistics')} />
                    </NavLink>
                    <NavLink to="/faq" className="nav-link expanded-nav-link">
                        <Button className="pt-minimal nav-button" icon="chat" text="FAQ" disabled={this.props.location.pathname.startsWith('/faq')} />
                    </NavLink>
                    <NavLink to="/glossary" className="nav-link expanded-nav-link">
                        <Button className="pt-minimal nav-button" icon="book" text="Glossary" disabled={this.props.location.pathname.startsWith('/glossary')} />
                    </NavLink>
                </NavbarGroup>
                
            </Navbar>);
    }
}

export default withRouter(Header);


// WEBPACK FOOTER //
// ./src/components/Header/Header.js